import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./AddCalcullateFnCss.module.css";

import "./AddCalcullateFnCss.css";
import SubCom from "./SubCom";
import { AppContext } from "./App.context";
import SubCom2 from "./SubCom2";
import SubCom3 from "./SubCom3";

function AddCalcullateFnCss(props) {
  const [value1, setValue1] = useState(0);
  const [value2, setValue2] = useState(0);
  const [resualt, setResualt] = useState(0);

  const calculationFn = useMemo(() => {
    let resualt = parseInt(value1) + parseInt(value2);
    console.log("resualt :", resualt);

    return <div>text : {resualt}</div>;
  }, [value1, value2]);


  const appContext = useContext(AppContext);

  const inputElement = useRef();

  const changeV1 = (e) => {
    console.log(e);
    setValue1((prev) => {
      console.log("prev ", prev);
      return prev;
    });
    setValue1(e.target.value);
  };
  const changeV2 = (e) => {
    console.log(e);
    setValue2(e.target.value);
  };
  const addFn = () => {
    let resualt = parseInt(value1) + parseInt(value2);
    console.log("resualt :", resualt);
    setResualt(resualt);

    inputElement.current.value = resualt;

    appContext.setResualt(resualt)
  };

  useEffect(() => {
    setResualt("not calculate");
  }, []);

  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
    };
  }, []);

  useEffect(() => {
    console.log("value1 changed ", value1);
    //do something
  }, [value1]);

  return (
    <div>
      <h1>Add Callculate Fn CSS</h1>
      <div>
        value 1 : <input onChange={changeV1} />
      </div>
      <div>
        value 2 : <input onChange={changeV2} />
      </div>
      <button onClick={addFn}>call</button>
      <div>resualt (v1+v2) : {resualt}</div>

      <br />
      <div>
        inputElement : <input ref={inputElement} />
      </div>
      <br />
      {calculationFn}

      <div style={{ color: "yellow", padding: "5px" }}>text styles</div>
      <div class="text">text css</div>
      <div className={styles.text}>text css module</div>

      <SubCom resualt={resualt}></SubCom>
      
      {/* <SubCom2 ></SubCom2> */}
      <SubCom3 ></SubCom3>


    </div>
  );
}
export default AddCalcullateFnCss;
